import React, { useEffect } from 'react';
import { SingleDropzone as DefaultSingleDropzone, SingleUploaderFileCard } from './styled';
import { FormHelperText } from '../../../form-helper-text';
import { Title } from '../../components/title';
import { Caption } from '../../components/caption';
export const SingleUploader = (props) => {
    var _a;
    const { title, caption, dropzone, hintType, hint, rootProps, inputProps, files, onAttach, onDownload, onRemoveFile, onAbort, onPreview, maxSize, fixedPadding } = props;
    const Dropzone = dropzone !== null && dropzone !== void 0 ? dropzone : DefaultSingleDropzone;
    const hasFile = files.length !== 0;
    const hasError = ((_a = files[0]) === null || _a === void 0 ? void 0 : _a.uploadStatus) === 'error';
    useEffect(() => {
        if (files.length > 1) {
            onRemoveFile(files[0]);
        }
    }, [files]);
    return (React.createElement(React.Fragment, null,
        React.createElement(Dropzone, { ...rootProps, "$hasFile": hasFile, "data-testid": "file-uploader-dropzone" },
            React.createElement("input", { ...inputProps }),
            hasFile ? (React.createElement(SingleUploaderFileCard, { file: files[0], maxSize: maxSize, hasError: hasError, onAttach: onAttach, onRemoveFile: onRemoveFile, onAbort: onAbort, onPreview: onPreview, onDownload: onDownload, disabled: rootProps.disabled })) : (React.createElement(React.Fragment, null,
                React.createElement(Title, { title: title, isSingle: true }),
                React.createElement(Caption, { caption: caption, maxSize: maxSize })))),
        React.createElement(FormHelperText, { fixedPadding: fixedPadding, msgType: hintType }, hint)));
};
